module.exports = __webpack_public_path__ + "static/media/communityIcon.d1eeed06.svg";